export default {
    mobile: (v) => /^09[0|1|2|3][0-9]{8}$/.test(v),
    nationalCode: (v) => v.length === 10,
    latinAndNumbers: (v) => /^[A-Za-z0-9]+$/.test(v),
    persian: (v) => /^[\u0600-\u06FF\s]+$/.test(v),
    email: (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v),
}